// TODO wiki
// Member-specific transaction amount (in cents DKK) used for membership fee.
export const TRANSACTION_AMOUNT = 65000 * 1.25;
export const U18_MEMBERSHIP_URL_DA = '/bliv-medlem/medlemskab#hvis-du-er-under-18-aar';
export const U18_MEMBERSHIP_URL_EN = '/en/become-member/join-koda#if-you-are-under-18-years-old';
export const OLD_PUBLISHER_MEMBERSHIP_URL_DA = '/bliv-medlem/medlemskab-for-musikforlag';
export const OLD_PUBLISHER_MEMBERSHIP_URL_EN = '/become-member/music-publisher-membership';
export const MIT_KODA_URL = 'https://mit.koda.dk/log-ind';

export const MAIL_TO_REPERTOIRE = 'mailto:repertoire@koda.dk';
